<!--<h1 class="home-banner">{{title}}</h1>-->


<div class="container dashboard-container">
  <div class="row clearfix margin-t1 ">
    <div class="dashboard-section s bg-gradient-1 margin-t1X hide" style="width:41%;">
      <div class="section-content ">
        Coming Soon
      </div>

    </div>
    <div class="dashboard-section s bg-gradient-3 margin-t1X xxl" style="height:auto;">
      <div class="section-content " style="font-size:12px !important;padding:0 !important;">
        <followup-enquiries></followup-enquiries>
      </div>
    </div>
    <div class="dashboard-section s bg-gradient-2 margin-t1X hide" style="height:auto;width:16%;">
      <div class="section-content ">
        Coming Soon
      </div>
    </div>
  </div>
  <div class="clearfix margin-t1">
    <div *ngIf="hasSpecialAccess" class="dashboard-section input-section xxl"  >
      <daily-collection></daily-collection>
    </div>
    <div class="dashboard-section input-section xxl">
      <expiring-subscriptions></expiring-subscriptions>
    </div>
  </div>
</div>


